import React, { useEffect } from 'react';
import { Field, Form, Formik } from 'formik';
import { WizardContext } from 'react-albus';
import { ageValidation } from '../validations';
import { saveItem, getExistingData, hasData } from '../helper';
import WizardProgress from '../Components/WizardProgress';
import Header from '../Components/Header';
import FormikMaskedInput from '../../CommonComponents/FormikMaskedInput';
import { numberMask } from '../../CommonComponents/MaskedInput';

interface Props {
  wizard: WizardContext;
}

const Age: React.FC<Props> = ({ wizard }) => {
  const { next } = wizard;
  const { CurrentAge, SpouseCurrentAge } = getExistingData();

  return (
    <div id="ExpressWizard_Input_Retirement" className="adv-form ExpressWizard">
      <Header wizard={wizard} isFirstStep />
      <WizardProgress wizard={wizard} />

      <Formik
        initialValues={{
          CurrentAge: CurrentAge || '',
          SpouseCurrentAge: SpouseCurrentAge || '',
        }}
        validationSchema={ageValidation}
        onSubmit={value => {
          saveItem(value);
          next();
        }}
      >
        {({ errors, touched }) => (
          <Form>
            <ul className="questions">
              <li style={{ display: 'block' }}>
                <ul className="horizontal-layout">
                  <li>
                    <label>Your Age</label>
                    <div
                      className={`input underline ${
                        errors.CurrentAge && touched.CurrentAge ? 'invalid' : ''
                      }`}
                      style={{ width: '50px', margin: '0 auto', float: 'none' }}
                    >
                      <Field
                        name="CurrentAge"
                        component={FormikMaskedInput}
                        mask={numberMask}
                        placeholder="00"
                        maxLength="2"
                        width="50"
                      />
                    </div>
                  </li>
                  <li>
                    <label>Spouse's Age</label>
                    <div
                      className="input underline optional"
                      style={{ width: '50px', margin: '0 auto', float: 'none' }}
                    >
                      <Field
                        name="SpouseCurrentAge"
                        component={FormikMaskedInput}
                        mask={numberMask}
                        placeholder="00"
                        maxLength="2"
                        width="50"
                      />
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
            <div className="action">
              <button type="submit" className="primary flat next">
                Next
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default Age;
